import React, { Component, createRef } from "react";
import {
  GET,
  POST,
  loading,
  token,
  alert,
  Status,
} from "../components/CustomComponent.js";
import Navbar from "../components/Navbar.js";
import Footer from "../components/Footer.js";
import LOGO from "../assets/images/logo.png";
import "../assets/css/bootstrap.css";
import "../assets/css/style.css";
export default class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: global.work_data || [],
      type: "",
    };
  }
  async componentDidMount() {
    loading(false);
  }
  render() {
    const { data, type } = this.state;
    return (
      <div className="w-100 min-vh-100 background position-relative">
        <Navbar />

        {/* SECTION 1 */}
        <div className="w-100 bg-blue text-white align-content-center">
          <div className="container mx-auto px-4 text-center py-5">
            <div className="my-5">
              <h1 className="fw-bold mb-4">ผลงานของเรา</h1>
              <h5 className="mb-3">
                ชมผลงานการพัฒนาระบบและแอปพลิเคชันที่เราได้สร้างให้กับลูกค้า
              </h5>
            </div>
          </div>
        </div>

        {/* SECTION 1 */}
        <div className="d-flex flex-wrap justify-content-center py-4">
          <button
            className={`btn btn-${type === "" ? "primary" : "light"} px-4 mx-1 mb-2`}
            onClick={() => {
              this.setState({ type: "" });
            }}
          >
            ทั้งหมด
          </button>
          <button
            className={`btn btn-${
              type === "website" ? "primary" : "light"
            } px-4 mx-1 mb-2`}
            onClick={() => {
              this.setState({ type: "website" });
            }}
          >
            เว็บไซต์
          </button>
          <button
            className={`btn btn-${
              type === "application" ? "primary" : "light"
            } px-4 mx-1 mb-2`}
            onClick={() => {
              this.setState({ type: "application" });
            }}
          >
            แอปพลิเคชัน
          </button>
          <button
            className={`btn btn-${
              type === "pos" ? "primary" : "light"
            } px-4 mx-1 mb-2`}
            onClick={() => {
              this.setState({ type: "pos" });
            }}
          >
            POS
          </button>
          <button
            className={`btn btn-${
              type === "iot" ? "primary" : "light"
            } px-4 mx-1 mb-2`}
            onClick={() => {
              this.setState({ type: "iot" });
            }}
          >
            ระบบ IoT
          </button>
        </div>
        {/* SECTION 2 */}
        <div className="w-100 bg-white align-content-center py-5">
          <div className="row container mx-auto justify-content-center">
            {data
              .filter((e) => !type || e.type.includes(type))
              .map((item, index) => (
                <div className="col-12 col-md-6 col-xl-4 col-xxl-3 mb-3 p-1">
                  <div
                    className="card card-dashboard mx-auto bg-white rounded-4 bg-white overflow-hidden h-100 pointer"
                    onClick={() => {}}
                  >
                    <div className="w-100 hpx-270 bg-light d-flex align-items-center justify-content-center position-relative">
                      {item.image_url ? (
                        <img
                          alt="LOGO"
                          src={item.image_url}
                          className="h-100 w-100 mx-auto my-5"
                          style={{ objectFit: "cover" }}
                        />
                      ) : (
                        <img
                          alt="LOGO"
                          src={LOGO}
                          className="h-100 w-75 mx-auto my-5"
                          style={{ objectFit: "contain" }}
                        />
                      )}

                      <div className="d-flex flex-wrap position-absolute"
                        style={{ top: 10, right: 10 }}>
                        {item.type
                          .split(",")
                          .map((tag, idx) => Status(tag, "primary"))}
                           {Status(index+1, "danger")}
                      </div>
                    </div>
                    <div className="w-100 p-3">
                      <h6
                        className="fw-bold w-100 overflow-hidden mb-2 text-nowrap"
                        style={{ textOverflow: "ellipsis" }}
                      >
                        {item.title || ""}
                      </h6>
                      <p
                        className="w-100 overflow-hidden text-secondary text-14"
                        style={{
                          display: "-webkit-box",
                          WebkitLineClamp: 3,
                          WebkitBoxOrient: "vertical",
                          textOverflow: "ellipsis",
                          lineHeight: "1.5em",
                        }}
                      >
                        {item.description || ""}
                      </p>

                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>

        {/* SECTION 3 */}
        <div className="w-100 align-content-center">
          <div className="container mx-auto px-4 text-center py-5">
            <div className="my-5">
              <h1 className="fw-bold mb-4">
                พร้อมสร้างผลงานใหม่กับเราแล้วหรือยัง?
              </h1>
              <h5 className="mb-3">
                ไม่ว่าจะเป็นเว็บไซต์ แอปพลิเคชัน หรือระบบ IoT
                เราพร้อมพัฒนาให้คุณ
              </h5>
              <div className="d-flex flex-wrap justify-content-center">
                <a className="btn btn-primary px-4 mx-1 mb-2" href="/contact?subject=เริ่มต้นโครงการใหม่">
                  เริ่มต้นโครงการใหม่
                </a>
                <a className="btn btn-light px-4 mx-1 mb-2" href="/contact?subject=นัดหมายปรึกษา">
                  ติดต่อเราเพื่อปรึกษา
                </a>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}
